var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.692 5.475-2.967-2.992a.624.624 0 0 0-.441-.183H6.258c-.575 0-1.041.467-1.041 1.042v1.041H4.175c-.575 0-1.042.467-1.042 1.042v11.208c0 .567.467 1.034 1.034 1.042l9.533.042h.009c.566 0 1.033-.459 1.041-1.042v-1.05h1.034c.274 0 .533-.108.733-.3.2-.2.308-.458.308-.733l.042-8.675a.625.625 0 0 0-.184-.442h.009Zm-1.75.017H13.7V4.233l1.242 1.259ZM13.5 16.458l-9.117-.041V5.625h.834v8.917a1.04 1.04 0 0 0 1.033 1.041l7.25.034v.841Zm-7.042-2.133V3.542h5.992v2.15a1.03 1.03 0 0 0 1.034 1.041h2.124l-.033 7.634-9.117-.042Zm1.659-4.308 5.833-.025a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625l-5.833.025a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625Zm.008 1.241 5.834-.025a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625l-5.834.025a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625Z",
    fill: "current"
  })));
};
export default SvgDocuments;